<template>
  <tr :class="[{'danger': hasErrors()}]">
    <td :class="['text-center', {'has-error': hasFieldErrors('dateText')}]">
      <input type="hidden" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].mediaInsertionRef.id'"
             v-model="kpiActual.mediaInsertionRef.id"/>
      <input type="hidden" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].periodStartDateText'"
             v-model="kpiActual.periodStartDateText"/>
      <input type="hidden" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].periodEndDateText'"
             v-model="kpiActual.periodEndDateText"/>
      <p class="form-control-static">{{ kpiActual.periodStartDateText }}</p>
      <span v-for="(error, index) in getFieldErrors('dateText')"
            :key="'dateText' + index" class="help-block">{{ error }}</span>
    </td>

    <!--Net cost-->
    <td v-if="pKpiFieldActivationRules.costActivated"
        :class="{'has-error': hasFieldErrors('actualTotalNetCostText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualTotalNetCostText'"
             v-model="kpiActual.actualTotalNetCostText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualTotalNetCostText')"
            :key="'actualTotalNetCostText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.costActivated">
        <p class="form-control-static text-muted text-nowrap text-nowrap"><em>{{ kpiActual.plannedTotalNetCostText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Spots-->
    <td v-if="pKpiFieldActivationRules.kpiSpotsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfSpotsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfSpotsText'"
             v-model="kpiActual.actualNbOfSpotsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfSpotsText')"
            :key="'actualNbOfSpotsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiSpotsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfSpotsText | emptyToDash}}</em></p>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiSpotsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForSpotsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForSpotsText'"
             v-model="kpiActual.actualCostForSpotsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForSpotsText')"
            :key="'actualCostForSpotsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiSpotsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForSpotsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Points-->
    <td v-if="pKpiFieldActivationRules.kpiPointsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfPointsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfPointsText'"
             v-model="kpiActual.actualNbOfPointsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfPointsText')"
            :key="'actualNbOfPointsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiPointsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfPointsText | emptyToDash}}</em></p>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiPointsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForPointsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForPointsText'"
             v-model="kpiActual.actualCostForPointsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForPointsText')"
            :key="'actualCostForPointsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiPointsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForPointsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Impressions-->
    <td v-if="pKpiFieldActivationRules.kpiImpressionsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfImpressionsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfImpressionsText'"
             v-model="kpiActual.actualNbOfImpressionsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfImpressionsText')"
            :key="'actualNbOfImpressionsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiImpressionsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfImpressionsText | emptyToDash}}</em></p>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiImpressionsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForImpressionsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForImpressionsText'"
             v-model="kpiActual.actualCostForImpressionsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForImpressionsText')"
            :key="'actualCostForImpressionsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiImpressionsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForImpressionsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Actions-->
    <td v-if="pKpiFieldActivationRules.kpiActionsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfActionsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfActionsText'"
             v-model="kpiActual.actualNbOfActionsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfActionsText')"
            :key="'actualNbOfActionsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiActionsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfActionsText | emptyToDash}}</em></p>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiActionsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForActionsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForActionsText'"
             v-model="kpiActual.actualCostForActionsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForActionsText')"
            :key="'actualCostForActionsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiActionsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForActionsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Clicks-->
    <td v-if="pKpiFieldActivationRules.kpiClicksActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfClicksText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfClicksText'"
             v-model="kpiActual.actualNbOfClicksText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfClicksText')"
            :key="'actualNbOfClicksText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiClicksActivated">
      <p class="form-control-static">{{ kpiActual.plannedNbOfClicksText | emptyToDash}}</p>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiClicksActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForClicksText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForClicksText'"
             v-model="kpiActual.actualCostForClicksText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForClicksText')"
            :key="'actualCostForClicksText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiClicksActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForClicksText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Leads-->
    <td v-if="pKpiFieldActivationRules.kpiLeadsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfLeadsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfLeadsText'"
             v-model="kpiActual.actualNbOfLeadsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfLeadsText')"
            :key="'actualNbOfLeadsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiLeadsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfLeadsText | emptyToDash}}</em></p></td>
    <td v-if="pKpiFieldActivationRules.kpiLeadsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForLeadsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForLeadsText'"
             v-model="kpiActual.actualCostForLeadsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForLeadsText')"
            :key="'actualCostForLeadsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiLeadsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForLeadsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Views-->
    <td v-if="pKpiFieldActivationRules.kpiViewsActivated"
        :class="{'has-error': hasFieldErrors('actualNbOfViewsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualNbOfViewsText'"
             v-model="kpiActual.actualNbOfViewsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualNbOfViewsText')"
            :key="'actualNbOfViewsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiViewsActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedNbOfViewsText | emptyToDash}}</em></p></td>
    <td v-if="pKpiFieldActivationRules.kpiViewsActivated && pKpiCostForActivated"
        :class="{'has-error': hasFieldErrors('actualCostForViewsText')}">
      <input type="text" :name="'bulkCmdDataForm.kpiActualList['+pIndex+'].actualCostForViewsText'"
             v-model="kpiActual.actualCostForViewsText" class="form-control input-sm text-right" placeholder=""/>
      <span v-for="(error, index) in getFieldErrors('actualCostForViewsText')"
            :key="'actualCostForViewsText' + index" class="help-block">{{ error }}</span>
    </td>
    <td v-if="pKpiFieldActivationRules.kpiViewsActivated && pKpiCostForActivated">
      <p class="form-control-static text-muted text-nowrap"><em>{{ kpiActual.plannedCostForViewsText | money(pCurrencies, pCurrencyRef.id) | emptyToDash}}</em></p>
    </td>

    <!-- Filler -->
    <th v-if="pFillerVisible">&nbsp;</th>
  </tr>
</template>

<script>
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MetricKpiActualFormTableRow",
  mixins: [FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pErrorList: Object,
    pIndex: Number,
    pCurrencyRef: Object,
    pKpiCostForActivated: Boolean,
    pKpiFieldActivationRules: Object,
    pFillerVisible: Boolean,
    pFillerWidth: Number,
    pKpiActual: Object
  },
  data: function () {
    return {
      kpiActual: this.pKpiActual
    }
  },
  methods: {
    hasErrors: function () {
      return !$.isEmptyObject(this.pErrorList);
    },
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    }
  }
}
</script>

<style scoped>

</style>